module.exports = __webpack_public_path__ + "img/case2.d859b458.png";